import { useRef, useState } from 'react';
import { ContextMenuSurface } from 'src/modules/shared/components/molecules/dropdowns/context-menu-surface';
import Modal from 'src/modules/shared/components/molecules/modals/modal';
import { useCopyToClipboard } from 'src/modules/shared/hooks/modal';
import type { TimelineItemActionsProps } from '../../../types/timeline/item-actions.types';

/** Owns timeline actions while the shared surface owns all menu gestures. */
export function TimelineItemActions({
  children,
  label,
  details,
  copyText,
  menuSide = 'right',
  menuVariant = 'neutral',
}: TimelineItemActionsProps) {
  const [showDetails, setShowDetails] = useState(false);
  const surfaceRef = useRef<HTMLDivElement>(null);
  const copy = useCopyToClipboard();
  const items = [
    ...(details
      ? [
          {
            key: 'details',
            label: 'Ver detalles',
            onClick: () => setShowDetails(true),
          },
        ]
      : []),
    ...(copyText
      ? [
          {
            key: 'copy',
            label: 'Copiar texto',
            onClick: () => void copy(copyText),
          },
        ]
      : []),
  ];
  return (
    <>
      <ContextMenuSurface
        ref={surfaceRef}
        label={label}
        items={items}
        triggerPosition={menuSide === 'left' ? 'outside-start' : 'outside-end'}
        triggerVariant={menuVariant}
      >
        {children}
      </ContextMenuSurface>
      <Modal
        isOpen={showDetails}
        onClose={() => setShowDetails(false)}
        compact
        showCloseButton
        returnFocusRef={surfaceRef}
        ariaLabel="Detalles de la interacción"
        closeLabel="Cerrar detalles"
        bodyClassName="!p-5 !pr-12"
        body={details}
      />
    </>
  );
}
